export default __webpack_public_path__ + "static/media/secutix.a00b4eb6.png";